import React from 'react';
import { Box, Divider, Group, SimpleGrid, Stack, Text } from '@mantine/core';

// Gedeelde bouwstenen voor de zijvensters: één visuele taal voor alle niveaus.

// Gekleurde kopbalk met niveaulabel, titel en subtitel op één regel.
// offsetTop: extra ruimte bovenin zodat de titel niet achter de zwevende
// zoekbalk (top:12) valt; panelen zonder inhoud erboven geven dit mee.
// Sluiten gaat via de ◀-knop op de paneelrand, dus geen sluitkruis hier.
export function PaneelKop({ label, titel, subtitel, badge, offsetTop = 0 }) {
  return (
    <Box
      px="md" pb="sm"
      style={{
        background: 'var(--mantine-color-groen-6)', color: '#fff',
        paddingTop: `calc(var(--mantine-spacing-sm) + ${offsetTop}px)`,
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap={8} align="baseline" wrap="wrap" style={{ minWidth: 0 }}>
          <Text size="xs" tt="uppercase" fw={700} style={{ opacity: 0.75, letterSpacing: 1 }}>
            {label}
          </Text>
          <Text size="lg" fw={700} style={{ lineHeight: 1.2, wordBreak: 'break-word' }}>
            {titel}
          </Text>
          {subtitel && <Text size="sm" style={{ opacity: 0.85 }}>{subtitel}</Text>}
        </Group>
        {badge && <div style={{ flexShrink: 0 }}>{badge}</div>}
      </Group>
    </Box>
  );
}

// Twee-koloms feitenblok: klein grijs label boven de waarde.
// Items zonder waarde worden overgeslagen zodat er geen lege velden staan.
export function InfoGrid({ items }) {
  const zichtbaar = items.filter(
    i => i.waarde !== null && i.waarde !== undefined && String(i.waarde).trim() !== ''
  );
  if (!zichtbaar.length) return null;
  return (
    <SimpleGrid cols={2} spacing="xs" verticalSpacing="sm">
      {zichtbaar.map(({ label, waarde, gecentreerd }) => (
        <div key={label} style={gecentreerd ? { textAlign: 'center' } : undefined}>
          <Text size="xs" c="dimmed">{label}</Text>
          <Text size="sm" fw={600} component="div">{waarde}</Text>
        </div>
      ))}
    </SimpleGrid>
  );
}

// Sectie met een lijnkopje erboven.
export function Sectie({ titel, children }) {
  return (
    <Stack gap="xs">
      <Divider label={titel} labelPosition="left" />
      {children}
    </Stack>
  );
}

// Databasewaardes als "8316.0" netjes tonen; niet-numeriek blijft zoals het is.
export function netGetal(waarde, { duizendtallen = false } = {}) {
  if (waarde === null || waarde === undefined || String(waarde).trim() === '') return null;
  const n = Number(String(waarde).replace(',', '.'));
  if (Number.isNaN(n)) return String(waarde);
  const geheel = Math.round(n);
  return duizendtallen ? geheel.toLocaleString('nl-NL') : String(geheel);
}
